<form class="page d-flex flex-column custom-modal-content">
  <div id="svg" style="text-align:center"></div>
</form>